
export function AddThemeContent() {
  return (
    <>
      <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
        {/* <ExampleColorPicker /> */} NAS ADD
      </div>
    </>
  );
}
